module.exports = __webpack_public_path__ + "static/img/1.f6c534e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/1.png
// module id = xbD5
// module chunks = 0